// Indian States and Cities Database — richer, curated tier-1 + tier-2 towns
// per state / UT (~1500 place-names). Sourced from `data/stateCities.js` so
// the whole app shares a single truth-set. State names use the modern
// (post-2019) spellings — "Jammu & Kashmir", "Puducherry".

import { STATE_CITIES } from '../data/stateCities';
import { STATE_UNITS, unitsForState, primaryUnitOf, toSqft, fromSqft } from '../data/stateUnits';

// Legacy → new state name aliases. Older submissions in Mongo may still carry
// the old spelling ("Jammu and Kashmir") — normalise before lookup.
const STATE_ALIASES = {
  'Jammu and Kashmir': 'Jammu & Kashmir',
  'Andaman and Nicobar': 'Andaman & Nicobar',
  'Andaman and Nicobar Islands': 'Andaman & Nicobar',
  'Pondicherry': 'Puducherry',
  'Orissa': 'Odisha',
};
const normalizeStateName = (s) => (s ? STATE_ALIASES[s] || s : s);

// Alphabetically sorted list used by every state dropdown.
export const INDIAN_STATES = Object.keys(STATE_CITIES).sort();

// Kept for backwards-compat with older imports elsewhere in the codebase.
export const CITIES_BY_STATE = STATE_CITIES;

// Get all cities for a state (returns [] for unknown state).
export const getCitiesByState = (state) => STATE_CITIES[normalizeStateName(state)] || [];

// Get all cities (flat list, unique + sorted).
export const getAllCities = () =>
  Array.from(new Set(Object.values(STATE_CITIES).flat())).sort();

// Re-exports so any form can also derive the state's preferred land units.
export { STATE_UNITS, unitsForState, primaryUnitOf, toSqft, fromSqft, normalizeStateName };
